export type SurveyCopy = {
  header: { line1: string; line2: string };
  redirect: string;
  close: string;
  disqualification: string;
  hints: {
    waiting: string;
    multichoice: string;
    multiselect: string;
    others: string;
    multitext: string;
    customAnswer: string;
  };
  actions: {
    send: string;
    confirm: string;
    close: string;
    remove: string;
    continue: string;
    choose: string;
    editResponse: string;
    playVideo: string;
    pauseVideo: string;
    acknowledge: string;
    next: string;
    cancel: string;
    moveUp: string;
    moveDown: string;
    submit: string;
    undo: string;
    openInBrowser: string;
    dontKnow: string;
    retryVideo: string;
    auto: string;
    autoAnswer: string;
    comment: string;
    show: string;
    hide: string;
    deleteStoredValue: string;
  };
  labels: {
    option: string;
    chooseOption: string;
    number: string;
    rowOption: string;
    rowRange: string;
    rowRating: string;
    rowRatingScale: string;
    rating: string;
    ratingScale: string;
    surveyImage: string;
    questionImage: string;
    landscapeImage: string;
    avatar: string;
    hlsVideo: string;
    cipherPlayer: string;
    yourAnswer: string;
    surveyTitle: string;
    response: string;
    total: string;
    or: string;
    conjointOptions: string;
    videoDial: string;
    videoPlayback: string;
    textToHighlight: string;
    phoneNumber: string;
    surveyProgress: string;
    clientLogo: string;
    image: string;
    imagePreview: string;
    previewImage: string;
    preview: string;
    closeImagePreview: string;
    embeddedContent: string;
    storedValues: string;
    star: string;
    stars: string;
    emptyRating: string;
  };
  status: {
    loading: string;
    transitions: string[];
    secondsRemaining: string;
    countdown: string;
    highlighted: string;
    notHighlighted: string;
    highlightWord: string;
    highlighterHelp: string;
    groupProgress: string;
    groupProgressVisible: string;
    answered: string;
    readyToSubmit: string;
    needsCorrection: string;
    pending: string;
    removed: string;
    dontKnow: string;
    defaultResponse: string;
    imageViewed: string;
    videoViewed: string;
  };
  dropdown: {
    label: string;
    placeholder: string;
    noOptions: string;
    clear: string;
    close: string;
    open: string;
    loading: string;
  };
  phone: {
    label: string;
    placeholder: string;
    search: string;
    noResults: string;
    countryNames: Record<string, string>;
  };
  validation: {
    response: string;
    number: string;
    phone: string;
    selectAvailable: string;
    selectCustomAnswer: string;
    selectAtLeastOne: string;
    tooManyOptions: string;
    invalidOption: string;
    exclusiveOptions: string;
    multiSelectCustomAnswer: string;
    rankRange: string;
    highlight: string;
    gridSelect: string;
    gridMultiSelect: string;
    invalidRowSelection: string;
    rating: string;
    rateEachRow: string;
    wholeNumbers: string;
    chooseEachRow: string;
    chooseTwo: string;
    chooseOne: string;
    minResponses: string;
    videoSaving: string;
    videoWatch: string;
  };
  errors: {
    generic: string;
    dialUnavailable: string;
    sessionClosed: string;
    commentUnavailable: string;
    unsupportedQuestion: string;
    requestTimeout: string;
    requestCancelled: string;
    requestDeadline: string;
    httpStatus: string;
  };
};

/** Substitute named parameters without interpreting survey-supplied values. */
export const formatCopy = (
  template: string,
  params: Record<string, string | number>,
): string =>
  template.replace(/\{(\w+)\}/g, (placeholder, key: string) =>
    Object.hasOwn(params, key) ? String(params[key]) : placeholder,
  );
